/* eslint-disable import/prefer-default-export */
import axios from '../config/axios';
import { store } from '../../js/store';

export function actualizarCuestionario(docId, variables, key, collection, creado_por) {
  return new Promise((resolve, reject) => {
    axios.put(`/formularios_cuestionarios/${collection}/api/v3/actualizar`, {
      docId,
      variables,
      key,
      creado_por,
    })
      .then((result) => {
        store.dispatch('setCargando', false);
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function consultarListaCuestionario(nombre, id) {
  return new Promise((resolve, reject) => {
    axios.get('/seguimiento_consultas/seguimientos/api/v2/cuestionarios', {
      params: {
        nombre,
        id,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}

export function consultarMarcaciones(documento) {
  return new Promise((resolve, reject) => {
    axios.post('/seguimiento_consultas/marcaciones/api/v1/marcaciones_paciente', {
      documento,
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}


export async function crearEncuentroSeguimiento(tipo_esquema, documento, creado_por) {
  try {
    return await axios.post('/seguimiento_consultas/seguimientos/api/v1/crear_seguimiento', {
      tipo_esquema,
      documento,
      creado_por,
    });
  } catch (error) {
    return error;
  }
}

export async function crearCuestionario(tipo_esquema, documento, creado_por, id, origen, tipo) {
  return await axios.post(`/formularios_cuestionarios/${tipo}/api/v3/crear`, {
    tipo_esquema,
    documento,
    creado_por,
    id,
    origen
  });
}

export async function crearFormulario(coleccion, creado_por, tipo_esquema, documento, id) {
  return await axios.post(`/formularios_cuestionarios/${coleccion}/api/v3/crear`, {
    tipo_esquema,
    documento,
    creado_por,
    id,
  });
}

export async function consultarEstructuraCuestionarioPorId(docId, tipo, tipo_esquema) {
  return await axios.get(`/formularios_cuestionarios/${tipo}/api/v3/leer`, {
    params: {
      docId,
      tipo_esquema,
    },
  });
}
export async function consultarEstructuraFormulario(docId) {
  return await axios.get('/formularios_cuestionarios/formularios/api/v2/leer', {
    params: {
      docId,
    },
  });
}
export async function consultarTipoEncuentroSeguimiento(origen, docId) {
  return await axios.get('/formularios_cuestionarios/gestion/api/v2/consultas_id', {
    params: {
      origen,
      docId,
    },
  });
}
export async function consultarNombresProgramas() {
  return await axios.get('/programas_marcaciones/programas/api/v3/consultar_nombres');
}
export async function consultarNombresProgramasDisponibles(documento) {
  return await axios.post('/programas_marcaciones/programas/api/v3/programas_disponibles', {
    documento,
  });
}
export async function crearNuevoPrograma(tipo_esquema, documento, creado_por, id = null, origen = null, momento = null) {
  return await axios.post('/programas_marcaciones/programas/api/v3/crear', {
    tipo_esquema, documento, creado_por, id, origen, momento,

  });
}
export async function consultarMarcacionesProgramasPaciente(documento) {
  return await axios.post('/programas_marcaciones/programas/api/v3/leer_todos', {
    documento,
  });
}
// export async function consultarMarcacionesProgramasPaciente(documento) {
//   return await axios.post('/programas_marcaciones/programas/api/v2/leer', {
//     documento,
//   });
// }
export async function actualizarMarcacionesProgramasPaciente(docId, creado_por, key, variables, collection) {
  return await axios.put(`/programas_marcaciones/${collection}/api/v3/actualizar`, {
    docId,
    creado_por,
    key,
    variables,
  });
}


// export async function consultarTipoEncuentroSeguimiento(origen, docId) {
//   return await axios.get('/formularios_cuestionarios/gestion/api/v2/consultas_id', {
//     params: {
//       origen,
//       docId,
//     },
//   });
// }



// WEBPACK FOOTER //
// ./src/apiService/request/CrudSeguimiento.js